export default __webpack_public_path__ + "static/media/photography.45618ce5.jpg";